// extracted by mini-css-extract-plugin
module.exports = {"viewport":"GalleryBlock_viewport__JOQUQ","slide":"GalleryBlock_slide__Z3iCj","slideIsThirdWindowWidth":"GalleryBlock_slideIsThirdWindowWidth__KrSHX"};